// @flow
export { default } from './UserTemplate';



// WEBPACK FOOTER //
// ./src/components/user/UserTemplate/index.js